import React from 'react';
import SalesTopX from './SalesTopX';
import { Card, CardTitle} from 'react-bootstrap';
import DateFnsFormat from 'date-fns/format';
import TotalSales from './TotalSales';
import WareHouseSales from './WareHouseSales';


class CustomerList extends React.Component {
  constructor(props) {
    super(props)
  }


  render() {
    
    const groupURL = "bill/sales/groups/" + DateFnsFormat(new Date(), 'yyyy') + "-01-01/" + DateFnsFormat(new Date(), 'yyyy-MM-dd') + "/30"; 
    const  garageUrl = "bill/sales/warehouse/Garage/" + DateFnsFormat(new Date(), 'yyyy') + "-01-01/" + DateFnsFormat(new Date(), 'yyyy-MM-dd') + "/100"; 
   
    return(
        <Card className="CustomerInsights 2024"   header="CustomerList">
        <CardTitle>Customer Information</CardTitle>
          <SalesTopX url={groupURL} title="Top Customers" />
           <SalesTopX url={garageUrl} title="Garage Customers" /> 
        </Card>
      )
    }
  
}

export default CustomerList;
